"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetProjectDeployments = exports.GetProjects = exports.GetProject = exports.ProjectFields = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.ProjectFields = (0, graphql_tag_1.default) `
  fragment ProjectFields on Project {
    id
    owner
    metadata
    currentVersion
    currentDeployment
    updatedTimestamp
    createdTimestamp
  }
`;
exports.GetProject = (0, graphql_tag_1.default) `
  query GetProject($id: String!) {
    project(id: $id) {
      ...ProjectFields
    }
  }
  ${exports.ProjectFields}
`;
exports.GetProjects = (0, graphql_tag_1.default) `
  query GetProjects($offset: Int) {
    projects(first: 10, offset: $offset) {
      totalCount
      nodes {
        ...ProjectFields
      }
    }
  }
  ${exports.ProjectFields}
`;
exports.GetProjectDeployments = (0, graphql_tag_1.default) `
  query GetProjectDeployments($projectId: String!) {
    project(id: $projectId) {
      deployments {
        totalCount
        nodes {
          id
          version
          createdTimestamp
        }
      }
    }
  }
`;
//# sourceMappingURL=project.generated.js.map